import React, { useState } from "react";
import '../styles/newac.css';
import leftImage from "../assets/landing1.png";

const CreateAccount = () => {
  const [mobileNumber, setMobileNumber] = useState("");

  const handleCreateAccount = () => {
    if (!mobileNumber.trim()) {
      alert("Please enter your mobile number");
      return;
    }

    if (!/^\d{10}$/.test(mobileNumber)) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    console.log("Mobile Number:", mobileNumber);
    alert(`Account creation OTP sent to ${mobileNumber}`);
    // Add your navigation logic here when needed
  };

  const handleLogin = () => {
    console.log("Navigate to login page");
    // Add your navigation logic here when needed
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleCreateAccount();
    }
  };

  return (
    <div className="create-page">
      {/* Left Image Section */}
      <div className="left-side">
        <img src={leftImage} alt="Lingayath Weds" className="left-image" />
      </div>

      {/* Right Create Account Section */}
      <div className="right-side">
        <div className="create-card">
          <h1 className="title">Welcome to Lingayath Weds</h1>
          <p className="note">
            <b>Note:</b> Create your new account here. <br />
            Already have an account? Please login.
          </p>

          <form>
            <label>Mobile Number*</label>
            <input
              type="text"
              placeholder="Enter Mobile Number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, ""))}
              onKeyPress={handleKeyPress}
              maxLength="10"
            />

            <button type="button" className="create-btn" onClick={handleCreateAccount}>
              Get OTP
            </button>
          </form>

          <hr />

          <p className="login-link">
            Already have an account? <span onClick={handleLogin}>Login</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;